import React from "react";
import { connect } from "react-redux";
import { Formik, Form, FormikProps } from "formik";

import { destroy, destroyAll, update } from "../redux/actions/itemsAction";
import Table from "./Table";

class ListForm extends React.Component<any, any> {
  state = null;

  constructor(props: any) {
    super(props);

    const { orderedItems } = this.props;
    const items = orderedItems.map((elm: any) => ({ ...elm, checked: false }));
    this.state = { initialValues: { items } };
  }

  render() {
    const { orderId, viewOnly } = this.props;
    const { initialValues } = this.state;

    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={() => {}}
      >
        {(formik: FormikProps<any>) => (
          <Form id="list-form">
            <Table formik={formik} orderId={orderId} viewOnly={viewOnly} />
          </Form>
        )}
      </Formik>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  orderedItems: state.orderedItems.data,
});

const mapDispatchToProps = { destroy, destroyAll, update };

export default connect(mapStateToProps, mapDispatchToProps)(ListForm);
